import Vue from 'vue'
import request from "./config/http.js"
import params from "./config/params.js"

let publicUrl = '/tsg-admin'
let url = publicUrl + "/sys/finance-order";
let url2 = publicUrl + "/sys/accountBill";
let url3 = publicUrl + "/sys/refund";
let url4 = publicUrl + "/sys/reviewerPerformance";
let url5 = publicUrl + "/sys/invoice";
let url6 = publicUrl + "/sys/e_charts";
let url7 = publicUrl + "/sys/found/audit"; // 基金审核
let url8 = publicUrl + "/sys/found/detail"; // 基金详情
let url9 = publicUrl + "/sys/found/list"; // 基金审核列表
let url10 = publicUrl + "/sys/found/completePage"; 
let url11 = publicUrl + "/sys/found/discountsList"; 
let url12 = publicUrl + "/sys/found/discountsPage"; // 基金优惠列表
let url13 = publicUrl + "/sys/found/discountAudit"; // 基金优惠列表
let reApply = publicUrl + "/sys/found/reApply"; // 基金优惠拒绝后再次申请
const apis = { 
  foundList(data) { // 基金审核列表
    return request({
      url: url9,
      method: 'get',
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  completePage(data) { // 审核完成列表
    return request({
      url: url10,
      method: 'get',
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  discountsPage(data) { // 基金优惠列表(已审核、未审核)
    return request({
      url: url12,
      method: 'get',
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  discountsList(data) { // 基金优惠金额列表
    return request({
      url: url11,
      method: 'get',
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  foundDetail(data) { // 基金详情
    return request({
      url: url8,
      method: 'get',
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  foundAudit(data) { // 基金审核
    return request({
      url: url7,
      method: 'post',
      data: data,
      jsonString: true,
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  reApply(data) { // 基金优惠拒绝后再次申请
    return request({
      url: reApply,
      method: 'post',
      data: data,
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  discountAudit(data) { // 基金审核
    return request({
      url: url13,
      method: 'post',
      data: data,
      jsonString: true,
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  auditAbnormal(data) {
    return request({
      url: publicUrl + "/sys/accountBill/auditAbnormal",
      method: 'post',
      data: data,
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  financeOrderList(data) {
    return request({
      url: publicUrl + "/sys/finance-order/list",
      method: 'get',
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  financeOrderDetail(data) {
    return request({
      url: publicUrl + "/sys/order/orderDetail",
      method: 'get',
      params: data
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },

  getBillList(data) {
    return request({
      url: url2 + "/queryAccountBillList",
      method: 'get',
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  auditAccountBill(data) {
    return request({
      url: publicUrl + '/sys/accountBill/auditAccountBill',
      method: 'post',
      data: data,
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  auditAccountBillForBatch(data) {
    return request({
      url: url2 + "/auditAccountBillForBatch",
      method: 'get',
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },

  queryRefundList(data) {
    return request({
      url: url3 + "/queryRefundList",
      method: 'get',
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  queryRefundInfo(orderId) {
    return request({
      url: url3 + '/queryRefundInfo',
      method: "get",
      params: {
        orderId: orderId
      }
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  queryReviewerUser(data) {
    return request({
      url: publicUrl + '/sys/reviewerPerformance/queryReviewUserByArticle',
      method: "get",
      params: data
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  refundTui(data) {
    return request({
      url: url3 + '/refund',
      method: "post",
      data: data
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  // 确认退款  
  refundSub(data) {
    return request({
      url: url3 + '/refundSub',
      method: "post",
      data: data
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  refundErrorList(data) {
    return request({
      url: url3 + "/refundErrorList",
      method: 'get',
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  queryInvoiceList(data) {
    return request({
      url: url5 + "/queryInvoiceList",
      method: 'get',
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  queryBilldetails(data) {
    return request({
      url: url5 + "/queryBilldetails",
      method: 'get',
      params: data
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  confirmInvoiceBill(data) {
    return request({
      url: url5 + '/confirmInvoiceBill',
      method: "post",
      jsonString: true,
      isToken: false,
      data: data
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  //退回开票申请
  bill(data) {
    return request({
      url: url5 + '/bill',
      method: "post",
      data: data
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  confirmBill(data) {
    return request({
      url: url5 + '/confirmBill',
      method: "post",
      isToken: false,
      data: data
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  viewBill(invoiceId) {
    return request({
      url: url5 + '/viewBill',
      method: "get",
      params: {
        invoiceId: invoiceId
      }
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },

  queryPerformanceList(data) {
    return request({
      url: url4 + '/queryPerformanceList',
      method: "get",
      params: data
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },

  histogram(data) {
    return request({
      url: url6 + '/histogram',
      method: "get",
      params: data
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  earnings(pressId) {
    return request({
      url: url6 + '/earnings',
      method: "get",
      params: {
        pressId: pressId
      }
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  graph(data) {
    return request({
      url: url6 + '/graph',
      method: "get",
      params: data
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  perList(data) { //期刊列表
    return request({
      url: publicUrl + '/sys/periodical/perList',
      method: "get",
      params: data
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  reviseOrderDetail(orderNum) { //编辑修改
    return request({
      url: publicUrl + '/sys/finance-order/updInfo',
      method: "get",
      isToken: true,
      params: {
        orderNum: orderNum
      },
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  reviseOrderPush(data) { //编辑提交
    return request({
      url: '/sys/finance-order/updOrder',
      method: "post",
      isToken: true,
      data: data,
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  reviseSendCode(data) { //编辑部订单身份校验
    return request({
      url: `/sys/user/sendCode?phone=${data.phone}`,
      method: 'post'
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  reviseCheckCodes(data) { //编辑部订单身份校验验证码
    return request({
      url: '/sys/user/verifyCode',
      method: 'post',
      data: data
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  verifyDetail(orderNum) { //财务审核
    return request({
      url: '/sys/finance-order/auditInfo',
      method: "get",
      isToken: true,
      params: {
        orderNum: orderNum
      },
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  verifyPay (data) { //财务订单审核确认支付
    return request({
      url: publicUrl + '/sys/finance-order/orderConfirmed',
      method: "post",
      data: data
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  verifyRowback(data) { //财务订单审核确认未支付
    return request({
      url: `/sys/finance-order/orderRefused?orderNum=${data}`,
      method: "post",
      isToken: true,
      data: data,
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  //汇款管理列表  
  queryAccountOrder(data) { 
    return request({
      url:publicUrl+ '/sys/order/queryAccountOrder',
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  //汇款订单审核
  auditOrderInfoCheck(data) { 
    return request({
      url:publicUrl+ '/sys/order/auditOrderInfoCheck',
      method: "post",
      data: data,
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },

  // v2.9.5 新增 财务订单查询 导入开票订单 sys/order/upOrderExcel
  upOrderExcel(data) {

    return request({
      url: publicUrl + "/sys/order/upOrderExcel",
      method: "post",
      data: data,
      headers: { "Content-Type": "multipart/form-data" },
      dataType: "formData"

    }).then((result) => {
      return Promise.resolve(result.data);
    });
  }

}


export default apis


// WEBPACK FOOTER //
// ./src/core/api/finance.serve.js